require("../coord/parallel/parallelCreator");

require("./axis/parallelAxisAction");

require("./axis/ParallelAxisView");


//////////////////
// WEBPACK FOOTER
// ../~/echarts/lib/component/parallelAxis.js
// module id = 2172
// module chunks = 1